<mat-icon fontSet="vp" [fontIcon]="icon"><ng-content></ng-content></mat-icon>
